import React from 'react';
import { string } from 'prop-types';
import { grey_1100 } from '@fiverr-private/sass/helpers/index';
import { Icon } from '@fiverr-private/fit';
import { r_pin } from '@fiverr-private/icons';
import { I18n } from '@fiverr-private/i18n-react';

const Location = ({ className, countryCode }) => (
    <div className={className}>
        <Icon color={grey_1100}>{r_pin}</Icon>
        <span className="m-l-8 text-semi-bold co-text-darker"><I18n k={`countries.${countryCode}`}/></span>
    </div>
);

Location.propTypes = {
    className: string,
    countryCode: string
};

export default Location;
